import {Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output} from '@angular/core';
import {LoadingIconSize} from '../../icon/loading-icon/loading-icon.component';

@Component({
  selector: 'awair-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  LoadingIconSize = LoadingIconSize;

  @HostListener('mouseover') mouseOver() {
    if (!this.hostDisabled) {
      this.hostOpacity = '0.8';
    }
  }
  @HostListener('mouseout') mouseOut() {
    if (!this.hostDisabled) {
      this.hostOpacity = '1';
    }
  }
  @HostListener('click', ['$event'])
  _haltDisabledEvents(event: Event) {
    // A disabled button shouldn't apply any actions
    if (this.hostDisabled) {
      event.stopPropagation();
    } else {
      this.btnClick.emit();
    }
  }

  @HostBinding('style.opacity') hostOpacity: string = '1';
  @HostBinding('style.cursor') hostCursor: string = 'pointer';
  @HostBinding('style.backgroundColor') hostBackgroundColor: string;
  @HostBinding('style.color') hostFontColor: string;

  get hostDisabled(): boolean {
    if (this._hostDisabled != null) {
      return this._hostDisabled;
    }
  }
  @Input()
  set hostDisabled(value: boolean) {
    if (value != null) {
      this._hostDisabled = value;
      this.hostCursor = value ? 'initial' : 'pointer';
      this.hostOpacity = value ? '0.6' : '1';
    }
  }
  private _hostDisabled: boolean;

  @HostBinding('class.--loading') hostLoading: boolean = false;

  @Input()
  set isLoading(value: boolean) {
    if (value != null) {
      this.hostLoading = value;
    }
  }

  @Output() btnClick: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}
